<template>
  <HourTradingDetail v-if="showHourTrading" :stock="stock" />
</template>
<script>
import { SEC_TYPE, TRADING_STATUS } from 'const/stock'
import { mapGetters } from 'vuex'
import HourTradingDetail from './Detail'
export default {
  name: 'HourTrading',
  components: { HourTradingDetail },
  props: {
    stock: Object
  },
  computed: {
    ...mapGetters(['usTradingStatus']),
    showHourTrading() {
      return (
        !this.stock.isIndex &&
        this.stock.secType !== SEC_TYPE.OPT &&
        this.stock.hourTradingLatestPrice &&
        this.stock.tradingStatus !== TRADING_STATUS.TRADING &&
        this.stock.tradingStatus === this.usTradingStatus
      )
    }
  }
}
</script>
